// extracted by mini-css-extract-plugin
export default {"container":"Relaunch_container__05t5v","content":"Relaunch_content__lWFQ-"};